import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor() { }
   data:GroupData;
   Group_Key:any;
}
interface GroupData { 
    createdAt:any,
    updatedAt: any,
    groupName: string,
    selectedgroupapplist: [],
    sharedusers: [],
    description: string,
    groupType: string,
    visibility:string
} 
